// extracted by mini-css-extract-plugin
module.exports = {"overlay":"videos-module--overlay--1De7L","carousel":"videos-module--carousel--2taX-"};